import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicalCrossSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="medical-cross-square, first-aid, emergency"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path fillRule="evenodd" clipRule="evenodd" d="M13.5 10.5V7.75H10.5V10.5H7.75V13.5H10.5V16.25H13.5V13.5H16.25V10.5H13.5Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMedicalCrossSquare;
